<span class="back-link">
    <div (click)="backClicked()"><i class="icon" [inlineSVG]="'#chevron_left'"></i>{{ title | translate }}</div>


    <i *ngIf="skin.whiteLabel === 'TRACKI'" class="icon close-menu" [inlineSVG]="'#arrow-to-left-line'"
        (click)="closeMenu()"></i>
</span>